import { useModal } from '@shared/model/useModal';

export const useAppointmentModal = () => useModal('appointment')